import { apiCreate, apiGetOne } from "./crud"

export const apiCreateTransaction = async (user_id: number, type_transaction: 'debit' | 'credit', amount: number) => {
    return await apiCreate<Api.Response.Transaction>('transaction', { user_id, type_transaction, amount })
}

export const apiCreatePayment = async (amount: number, code: string) => {
    return await apiCreate<Api.Response.Charge>('user/create_payment', { amount, code })
}